import { AccountActivationResult as AccountActivationResultDto } from 'gleblu-socket-api';

import AccountActivationResult from '../interfaces/AccountActivationResult';

export function fromDto(accountActivationDto: AccountActivationResultDto): AccountActivationResult {
  return AccountActivationResult[accountActivationDto];
}

export function toDto(_: AccountActivationResult): AccountActivationResultDto {
  throw new Error('Not supported');
}
